import * as React from 'react';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

import { getAuth, createUserWithEmailAndPassword, updateProfile, onAuthStateChanged } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { db } from '..';
import { useNavigate } from 'react-router-dom';
import { CButton } from '../components';
import { Alert, Collapse, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import validator from 'validator'
import { handleAuthError } from './LoginPage';



export default function RegisterPage() {

    const [alert, setAlert] = React.useState(false);
    const [alertMessage, setAlertMessage] = React.useState("");

    const auth = getAuth();
    const navigate = useNavigate()

    onAuthStateChanged(auth, (user) => {
        if (user) {
            // User is signed in, see docs for a list of available properties
            // https://firebase.google.com/docs/reference/js/firebase.User
            const uid = user.uid;
            navigate("/")
            // ...
        } else {
            // User is signed out

        }
    });

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);

        if (!data.get('firstName')) {
            setAlertMessage("Adınızı giriniz.")
            setAlert(true)

        } else if(!data.get('lastName')) {
            setAlertMessage("Soyadınızı giriniz.")
            setAlert(true)

        } else if (!validator.isEmail(data.get('email'))) {
            setAlertMessage("Uygun bir eposta adresi giriniz.")
            setAlert(true)

        } else if (!data.get('password')) {
            setAlertMessage("Şifrenizi girmediniz.")
            setAlert(true)

        } else {
            createUserWithEmailAndPassword(auth, data.get('email'), data.get('password'))
            .then((userCredential) => {
                // Signed in 
                const fullName = `${data.get('firstName')} ${data.get('lastName')}`

                // Create user in Firestore
                setDoc(doc(db, "users", auth.currentUser.uid), {
                    firstName: data.get('firstName'),
                    lastName: data.get('lastName'),
                    fullName: fullName,
                    hatms: [],
                }).then(() => {

                    // Navigate to 'giris'
                    updateProfile(auth.currentUser, {
                        displayName: fullName
                    }).then(() => {
                        //window.location.href = '/login';
                    }).catch((error) => {
                        // An error occurred
                        // ...
                        alert(error.message)
                    });
                }).catch((error) => {
                    alert(error.message)
                })
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                // ..

                console.log(error.code)

                setAlertMessage(handleAuthError(error.code))
                setAlert(true)
            });
        }

        
    };

    return (
        <Container component="main" maxWidth="xs">
            <Collapse in={alert}>
                <Alert
                    severity="error"
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                setAlert(false);
                            }}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }
                    sx={{ mb: 2 }}
                >
                    {alertMessage}
                </Alert>
            </Collapse>
            <Box
                marginBottom={"15px"}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                    <TextField
                        margin="dense"
                        autoComplete="given-name"
                        name="firstName"
                        required
                        fullWidth
                        id="firstName"
                        label="Adınız"
                        autoFocus
                    />
                    <TextField
                        margin="dense"
                        required
                        fullWidth
                        id="lastName"
                        label="Soyadınız"
                        name="lastName"
                        autoComplete="family-name"
                    />
                    <TextField
                        margin="dense"
                        required
                        fullWidth
                        id="email"
                        label="Eposta Adresiniz"
                        name="email"
                        autoComplete="email"
                    />
                    <TextField
                        margin="dense"
                        required
                        fullWidth
                        name="password"
                        label="Şifreniz"
                        type="password"
                        id="password"
                        autoComplete="new-password"
                    />
                    <CButton
                        type="submit">
                        Kayıt Ol
                    </CButton>
                    <Grid marginTop={'15px'} container>
                        <Link style={{ all: "unset" }} href="/giris" variant="body2">
                            Hesabıma giriş yapacağım.
                        </Link>
                    </Grid>
                </Box>
            </Box>
        </Container>


    );
}